const zh = {
  // 页面标题
  pageTitle: "Wevoov 账户注销服务",
  pageSubtitle: "Wevoov 用户账户注销平台",
  
  // 步骤标题（用于步骤条）
  step1Title: "输入ID",
  step2Title: "确认", 
  step3Title: "验证",
  step4Title: "完成",
  
  // 步骤描述
  step1Desc: "验证身份",
  step2Desc: "发送验证码",
  step3Desc: "确认注销",
  step4Desc: "操作成功",
  
  // 完整步骤标题（用于内容区域）
  step1FullTitle: "第一步：输入用户ID",
  step2FullTitle: "第二步：确认用户信息", 
  step3FullTitle: "第三步：输入验证码",
  step4FullTitle: "注销完成",
  
  // 第一步
  step1Instruction: "请输入您要注销的用户ID，我们将验证您的身份",
  userIdPlaceholder: "请输入用户ID",
  getUserInfoButton: "获取用户信息",
  
  // 第二步
  step2Instruction: "确认以上用户信息无误后，点击下方按钮发送验证码到您的Wevoov App",
  userInfoLabel: "用户ID",
  sendCodeButton: "发送验证码",
  
  // 第三步
  step3Instruction: "请打开您的Wevoov App查收验证码，然后输入下方验证码完成账户注销",
  codePlaceholder: "请输入验证码",
  confirmDeleteButton: "确认注销账户",
  
  // 第四步
  successTitle: "账户注销成功！",
  successSubtitle: "您的账户信息已被成功注销，感谢您使用我们的服务",
  restartButton: "重新开始",
  
  // 消息提示
  messages: {
    enterUserId: "请输入用户ID",
    getUserInfoSuccess: "用户信息获取成功",
    getUserInfoFailed: "获取用户信息失败",
    sendCodeSuccess: "验证码发送成功！请打开Wevoov App查收验证码",
    sendCodeFailed: "发送验证码失败",
    enterCode: "请输入验证码",
    deleteSuccess: "账户注销成功！",
    deleteFailed: "账户注销失败",
    networkTimeout: "请求超时，请检查网络连接",
    networkError: "网络连接失败，请检查网络设置",
    retryNetwork: "正在检查网络连接...",
    networkNormal: "网络连接正常",
    networkStillFailed: "网络连接仍然失败"
  },
  
  // 网络错误
  networkErrorTitle: "网络连接异常",
  networkErrorDesc: "无法连接到服务器，请检查网络连接后重试",
  retryButton: "重试",
  
  // 按钮
  buttons: {
    retry: "重试",
    restart: "重新开始"
  }
};

export default zh; 